module.exports = __webpack_public_path__ + "static/media/linkedin-logo.853fe370.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedin-logo.svg
// module id = 1695
// module chunks = 0